import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';
import { RadioButtonWithLabelGroupWidget, TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { AskDataIndexing } from '~src/datasource/models/IDataSourceInfo';
import { AskDataMode } from '~src/settings/types/AskDataMode';

import { AskDataSettingsEditorState } from './AskDataSettingsEditorState';
import { Title } from './Title';

interface AskDataEditModeProps {
  readonly askDataMode: AskDataMode;
  readonly askDataIndexing: AskDataIndexing;
  readonly setEditorState: React.Dispatch<MergeOrUpdateStateAction<AskDataSettingsEditorState>>;
  readonly disableControls: boolean;
}

export function AskDataEditMode(props: AskDataEditModeProps): JSX.Element {
  return (
    <AskDataIndexingComponent
      askDataIndexing={props.askDataIndexing}
      setEditorState={props.setEditorState}
      disableButtons={props.disableControls}
    />
  );
}

const TEST_ID_PREFIX = 'ask-data-indexing';

interface AskDataIndexingProps {
  readonly askDataIndexing: AskDataIndexing;
  readonly setEditorState: React.Dispatch<MergeOrUpdateStateAction<AskDataSettingsEditorState>>;
  readonly disableButtons: boolean;
}

export function AskDataIndexingComponent(props: AskDataIndexingProps): JSX.Element {
  const radioButtonList = [
    {
      label: Messages.dataSourceNlpSetting_indexing_option_automatic(),
      testId: TEST_ID_PREFIX + 'automatic',
      value: AskDataIndexing.automatic,
      disabled: props.disableButtons,
    },
    {
      label: Messages.dataSourceNlpSetting_indexing_option_manual(),
      testId: TEST_ID_PREFIX + 'manual',
      value: AskDataIndexing.manual,
      disabled: props.disableButtons,
    },
    {
      label: Messages.dataSourceNlpSetting_indexing_option_disabled(),
      testId: TEST_ID_PREFIX + 'disabled',
      value: AskDataIndexing.disabled,
      disabled: props.disableButtons,
    },
  ];

  return (
    <div style={{ paddingBottom: TabStyles.Spacing.DefaultSpace }}>
      <Title>{Messages.dataSourceNlpSetting_option_Title()}</Title>
      <RadioButtonWithLabelGroupWidget
        aria-label={Messages.dataSourceNlpSetting_option_Title()}
        removeLeftMargin={true}
        buttonList={radioButtonList}
        checkedIndex={radioButtonList.findIndex(item => item.value === props.askDataIndexing)}
        handleChange={value => props.setEditorState({ askDataIndexing: value })}
      />
    </div>
  );
}
